<template>
    <router-link class="btn btn-primary" :to="{name: 'logout'}">
        <slot>Kilépés</slot>
    </router-link>
</template>
